import React from 'react';
import { Box, Checkbox, FormControl, InputLabel, FormHelperText, Grid } from '@material-ui/core';
import { useField, useFormikContext } from 'formik';
import useTranslation from 'next-translate/useTranslation';

const FacilityCheckbox = ({ options, label, ...props }) => {
  const { t } = useTranslation('common');
  const [field, , helpers] = useField(props);
  const { isSubmitting, submitCount } = useFormikContext();

  const checkboxError =
    submitCount > 0 && (field.value.length === 0 || field.value.every(value => !value));
  return (
    <FormControl margin="normal" fullWidth>
      {label && (
        <Box mt={2}>
          <InputLabel htmlFor={props.name} shrink>
            {label}
          </InputLabel>
        </Box>
      )}

      {/* {checkboxError && (
        <FormHelperText error={checkboxError}>{(t('Please select at least one option'))}</FormHelperText>
      )} */}
      <Grid container>
      {options.map((option) => (
        <Grid  key={option} item xs={12} md={6}>
          <Checkbox
            type="checkbox"
            id={option}
            name={props.name}
            error={checkboxError}
            value={option}
            checked={field.value.includes(option)}
            onChange={() => {
              const newArray = field.value.includes(option)
                ? field.value.filter((fac) => fac !== option)
                : [...field.value, option];
              helpers.setValue(newArray);
            }}
            onBlur={() => helpers.setTouched(true)} // Trigger touched state for checkboxes
            disabled={isSubmitting}
          />
          <label htmlFor={option}>{option}</label>
        </Grid>
      ))}
      </Grid>
    </FormControl>
  );
};

export default FacilityCheckbox;
